var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home uk-container"},[_c('div',{staticClass:"sign uk-section uk-position-center"},[_c('div',{staticClass:"home-sign-text uk-flex uk-flex-center"},[_c('span',{staticClass:"sign-1"},[_vm._v("JACK")]),_c('span',{staticClass:"sign-1"},[_vm._v("CARPENTER")]),_c('span',{staticClass:"sign-2"},[_vm._v(".DEV")])])])])
}]

export { render, staticRenderFns }